import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {useChapterStatuses} from '#hooks/store/useChapterStatuses'
import AusbildungsplanQuestionSets from './AusbildungsplanQuestionSets'
import AusbildungsplanContentMenu from './AusbildungsplanContentMenu'
import {useAusbildungsplan} from '#hooks/useAusbildungsplan'

function AusbildungsplanSubmenuAsAzubi(props) {
  const {pathParts, contextualUserId} = props

  const {getStaticContent, ready, getQuestionsContent, findParent} = useAusbildungsplan(contextualUserId)
  const {isChapterSubmitted} = useChapterStatuses(contextualUserId)

  const isQuestionsContent = pathParts.includes('questions')

  const getLevel1Menu = () => (isQuestionsContent ? 'left' : '')
  const getLevel3Menu = () => (!isQuestionsContent ? 'right' : '')

  return (
    <>
      <AusbildungsplanContentMenu
        pageList={getStaticContent()}
        chapters={getQuestionsContent()}
        contextualUserId={contextualUserId}
        pathParts={pathParts}
        levelMenu={getLevel1Menu}
      />

      <div className={`menu-partial ${getLevel3Menu()}`}>
        <AusbildungsplanQuestionSets
          contextualUserId={contextualUserId}
          currentItem={pathParts[3]}
          ready={ready}
          findParent={findParent}
          isChapterSubmitted={isChapterSubmitted}
        />
      </div>
    </>
  )
}

AusbildungsplanSubmenuAsAzubi.propTypes = {
  pathParts: PropTypes.array.isRequired,
  contextualUserId: PropTypes.number,
}

export default AusbildungsplanSubmenuAsAzubi
